export const APPOINTMENT_TYPE_AI_CALL = 'ai-call';
export const APPOINTMENT_TYPE_WARBOX = 'warbox';
